(function () {
  var section = document.querySelector('.mcol');
  if (!section) return;

  var filters = section.querySelectorAll('.mcol__filter');
  var cards = section.querySelectorAll('.mcol__card');
  var empty = section.querySelector('.mcol__empty');

  function applyFilter(value) {
    var visibleCount = 0;

    cards.forEach(function (card) {
      var match = value === 'all' || card.getAttribute('data-continent') === value;
      card.classList.toggle('is-hidden', !match);
      if (match) visibleCount += 1;
    });

    if (empty) {
      empty.classList.toggle('is-visible', visibleCount === 0);
    }

    filters.forEach(function (btn) {
      btn.classList.toggle('is-active', btn.getAttribute('data-filter') === value);
    });
  }

  filters.forEach(function (btn) {
    btn.addEventListener('click', function () {
      var value = btn.getAttribute('data-filter');
      applyFilter(value);

      var url = new URL(window.location.href);
      if (value === 'all') {
        url.searchParams.delete('continent');
      } else {
        url.searchParams.set('continent', value);
      }
      window.history.replaceState({}, '', url);
    });
  });

  var initial = new URLSearchParams(window.location.search).get('continent') || 'all';
  applyFilter(initial);
})();
